export const articles = [
  {
    id: "article-001",
    title: "千万粉博主李某人设崩塌：私下辱骂粉丝录音曝光，品牌代言一夜全撤",
    summary: "近日，拥有千万粉丝的知名博主李某被曝出私下多次辱骂粉丝，多段录音在网络上疯传。事件发酵后，多个品牌方紧急宣布终止与李某的合作关系。",
    content: "据知情人士透露，李某在私下场合多次使用侮辱性语言评价自己的粉丝群体，这些言论被有心人录制下来。录音中，李某不仅对粉丝的购买力嗤之以鼻，还嘲笑粉丝\"人傻钱多\"。录音曝光后，李某的社交媒体账号评论区瞬间沦陷，大量粉丝表示\"脱粉\"。\n\n截至目前，已有三家知名品牌宣布与李某解约，预计李某此次将损失超过千万的商业代言收入。李某本人尚未对此事做出任何公开回应。",
    category: "网红塌房",
    categorySlug: "wanghong-tafang",
    date: "2026-07-06",
    views: "520万+",
    comments: "8.6万+",
    shares: "12.3万+",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20photography%2C%20shattered%20crown%20on%20black%20velvet%2C%20red%20and%20black%20cinematic%20lighting%2C%20broken%20pieces%20scattered%2C%20moody%20atmosphere%2C%20editorial%20style%2C%20dark%20background%2C%20professional%20photography%2C%20dramatic%20shadows%2C%20subtle%20crimson%20glow&width=1920&height=800&seq=article-hero-01&orientation=landscape",
    ctaImageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20artistic%20photography%2C%20red%20and%20black%20waves%2C%20mysterious%20glow%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20dark%20background%2C%20professional%20fine%20art%20photography%2C%20dramatic%20textures&width=1200&height=600&seq=article-cta-01&orientation=landscape",
    tags: ["网红塌房", "人设崩塌", "粉丝脱粉", "品牌解约"],
    relatedArticles: ["article-002", "article-003", "article-006"],
  },
  {
    id: "article-002",
    title: "顶流带货主播涉嫌虚假宣传：质检报告造假，直播间被封禁72小时",
    summary: "某平台顶流带货主播被曝其所售产品质检报告造假。事件引发监管介入，该主播直播间被平台封禁72小时。",
    content: "据调查，该主播在直播中展示的质检报告存在多处PS痕迹。真正的质检报告显示，该产品多项指标不达标，属于不合格产品。但主播在直播间展示的\"质检报告\"却显示全部合格。\n\n事件曝光后，平台方迅速做出反应，对该主播直播间进行了72小时封禁处理。市场监管部门也已介入调查，如果查实，该主播将面临严厉处罚。",
    category: "黑料爆料",
    categorySlug: "heiliao-baoliao",
    date: "2026-07-05",
    views: "380万+",
    comments: "5.2万+",
    shares: "8.1万+",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20product%20photography%2C%20fake%20quality%20certificate%20on%20black%20surface%2C%20red%20stamp%20and%20warning%20signs%2C%20dramatic%20cinematic%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=1920&height=800&seq=article-hero-02&orientation=landscape",
    ctaImageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20photography%2C%20red%20and%20black%20geometric%20patterns%2C%20dramatic%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20fine%20art%20photography&width=1200&height=600&seq=article-cta-02&orientation=landscape",
    tags: ["黑料爆料", "虚假宣传", "带货主播", "质检造假"],
    relatedArticles: ["article-001", "article-004", "article-005"],
  },
  {
    id: "article-003",
    title: "情侣博主分手实为剧本炒作：前员工曝光团队策划内幕",
    summary: "一对拥有500万粉丝的情侣博主\"甜蜜分手\"事件被曝实为精心策划的剧本。前团队成员独家向本站爆料幕后操作全过程。",
    content: "前团队成员小张（化名）向本站透露，该情侣博主的所有\"甜蜜日常\"和\"分手大戏\"均为团队策划。\"他们根本不是情侣关系，只是签约的演员。每次的争吵、和好、出游都是按照剧本走的。\"小张表示，自己因看不下去这种欺骗粉丝的行为，选择离职并曝光真相。\n\n此消息一出，粉丝圈彻底炸锅。大量粉丝表示\"被耍了\"，要求该情侣博主退网并退还打赏。",
    category: "网红塌房",
    categorySlug: "wanghong-tafang",
    date: "2026-07-04",
    views: "450万+",
    comments: "7.1万+",
    shares: "10.5万+",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20romantic%20scene%20photography%2C%20broken%20heart%20prop%2C%20script%20papers%20and%20film%20camera%2C%20dramatic%20red%20and%20black%20cinematic%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=1920&height=800&seq=article-hero-03&orientation=landscape",
    ctaImageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20art%20photography%2C%20red%20crimson%20smoke%20patterns%2C%20mysterious%20atmosphere%2C%20editorial%20style%2C%20dramatic%20lighting%2C%20dark%20background%2C%20professional%20fine%20art%20photography&width=1200&height=600&seq=article-cta-03&orientation=landscape",
    tags: ["网红塌房", "情侣博主", "剧本炒作", "粉丝被骗"],
    relatedArticles: ["article-001", "article-002", "article-006"],
  },
  {
    id: "article-004",
    title: "电竞圈假赛风波：内部聊天记录曝光，涉及金额超千万",
    summary: "某知名电竞选手被曝参与假赛，内部聊天记录完整版流出。涉及多个战队和博彩平台，圈内震动。",
    content: "近日，一份涉及多位电竞选手的内部聊天记录在网络上疯传。聊天记录显示，某位冠军选手在多场比赛中故意放水，配合博彩平台操控比赛结果，涉案金额据估计超过千万元。\n\n电竞协会已发表声明，称将全力配合调查。涉事选手所在战队也紧急发布公告，表示将暂停该选手所有比赛资格，等待调查结果。",
    category: "黑料爆料",
    categorySlug: "heiliao-baoliao",
    date: "2026-07-05",
    views: "620万+",
    comments: "9.8万+",
    shares: "15.2万+",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20esports%20photography%2C%20gaming%20arena%20with%20red%20ambient%20lighting%2C%20shattered%20trophy%2C%20dramatic%20cinematic%20atmosphere%2C%20editorial%20style%2C%20moody%20noir%20lighting%2C%20dark%20background%2C%20professional%20photography&width=1920&height=800&seq=article-hero-04&orientation=landscape",
    ctaImageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20photography%2C%20red%20digital%20patterns%2C%20dramatic%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20fine%20art%20photography&width=1200&height=600&seq=article-cta-04&orientation=landscape",
    tags: ["黑料爆料", "电竞圈", "假赛", "博彩"],
    relatedArticles: ["article-002", "article-005"],
  },
  {
    id: "article-005",
    title: "健身达人卖假补剂被粉丝集体起诉，涉及金额超三百万",
    summary: "拥有200万粉丝的健身博主被曝销售假冒蛋白粉和营养补剂，多名粉丝已联合委托律师提起诉讼。",
    content: "据了解，陈教练在直播中推荐并销售的多款蛋白粉和营养补剂，经专业机构检测为假冒伪劣产品。这些产品不仅成分与标注严重不符，部分批次还检测出了有害物质。\n\n目前已有超过200名消费者联合委托律师事务所，准备对陈教练及其背后的公司提起集体诉讼。原告方代理律师表示，索赔总金额预计将超过三百万元。",
    category: "网红塌房",
    categorySlug: "wanghong-tafang",
    date: "2026-07-03",
    views: "290万+",
    comments: "4.5万+",
    shares: "6.7万+",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20fitness%20photography%2C%20protein%20powder%20and%20supplements%20on%20black%20surface%2C%20legal%20documents%20nearby%2C%20dramatic%20red%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=1920&height=800&seq=article-hero-05&orientation=landscape",
    ctaImageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20artistic%20photography%2C%20red%20and%20black%20gradients%2C%20mysterious%20glow%2C%20editorial%20style%2C%20dramatic%20lighting%2C%20dark%20background%2C%20professional%20fine%20art%20photography&width=1200&height=600&seq=article-cta-05&orientation=landscape",
    tags: ["网红塌房", "假货", "集体诉讼", "健身博主"],
    relatedArticles: ["article-001", "article-004"],
  },
  {
    id: "article-006",
    title: "知名大V学历造假深扒：自称海外博士，实际未完成高中学业",
    summary: "某微博百万粉丝大V被扒出学历造假。自称哈佛博士，实则连高中都未毕业。多所高校已发声明撇清关系。",
    content: "经本站记者深入调查，这位经常在微博上以\"哈佛博士\"身份发表各种\"深度分析\"的百万粉丝大V，实际上连高中学业都未完成。该大V原名王某，曾在某县城高中就读，高二时因成绩太差被学校劝退。\n\n此后王某辗转多个城市打工，后来自学了一些营销知识，开始在社交媒体上包装自己为\"海外归国博士\"，并以此为卖点吸引粉丝、接广告赚钱。目前王某的微博账号已被平台限制，其多个广告合作也已被品牌方单方面终止。",
    category: "黑料爆料",
    categorySlug: "heiliao-baoliao",
    date: "2026-07-02",
    views: "480万+",
    comments: "6.3万+",
    shares: "9.8万+",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20photography%20of%20fake%20diplomas%20and%20certificates%2C%20university%20documents%20on%20black%20desk%2C%20dramatic%20red%20and%20black%20lighting%2C%20editorial%20style%2C%20moody%20noir%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=1920&height=800&seq=article-hero-06&orientation=landscape",
    ctaImageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20photography%2C%20red%20academic%20patterns%2C%20dramatic%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20fine%20art%20photography&width=1200&height=600&seq=article-cta-06&orientation=landscape",
    tags: ["黑料爆料", "学历造假", "微博大V", "人设崩塌"],
    relatedArticles: ["article-001", "article-003"],
  },
];

export const faqs = [
  {
    question: "你们的信息来源可靠吗？",
    answer: "我们所有爆料内容均来自公开信息和多方交叉验证。每篇报道都会标注信息来源，确保内容真实可信。对于无法核实的信息，我们会明确标注\"未经证实\"。",
  },
  {
    question: "爆料人的隐私如何保护？",
    answer: "我们严格保护所有爆料人的个人信息，所有投稿均采用匿名处理。我们永远不会在未经爆料人同意的情况下公开任何可以识别其身份的信息。",
  },
  {
    question: "可以投稿爆料吗？",
    answer: "当然可以！我们欢迎所有真实、有据可查的爆料。请通过我们的官方邮箱或社交媒体私信提交，我们的编辑团队会在24小时内审核并回复。",
  },
  {
    question: "被爆料方要求删除内容怎么办？",
    answer: "我们始终坚持新闻真实性原则。如果被爆料方能够提供确凿证据证明我们的报道存在失实，我们会立即更正。但如果报道内容属实，我们不会因为外部压力而撤稿。",
  },
];